import Vue from 'vue'
import App from './App.vue'
import router from './router'
import component from './components/vue-dropdown-menu.vue';

import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/main.css'


console.log(Vue.version);

Vue.config.productionTip = false;

//local.nftstitches.com for cookies
var isLocal = false;

Vue.prototype.$xummhost = 'https://strategyengine.one/api/xumm';
Vue.prototype.$reporthost = 'https://strategyengine.one/api/reports';
Vue.prototype.$fsehost = 'https://strategyengine.one/api/distribution';



if (isLocal) {
  Vue.prototype.$xummhost = 'http://local.strategyengine.one:8085';
  Vue.prototype.$nfthost = 'http://local.strategyengine.one:8081';
  //  Vue.prototype.$reporthost = 'http://local.strategyengine.one:8080';
  //  Vue.prototype.$fsehost = 'http://local.strategyengine.one:8080';
} else {
  Vue.prototype.$nfthost = 'https://strategyengine.one/api/nftstitches';
  Vue.prototype.$xummhost = 'https://strategyengine.one/api/xumm';
  Vue.prototype.$xrplnft = 'https://nftstitches.com/api/xrplnft';
  Vue.prototype.$reporthost = 'https://strategyengine.one/api/reports';
  Vue.prototype.$fsehost = 'https://strategyengine.one/api/distribution';
}




const install = function installVueDropdownMenu(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('VueDropdownMenu', component);
};

component.install = install;

export default component;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');